exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-788f7aff]::after {\n  content: \"*\";\n  color: red;\n  margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-788f7aff] {\n  font-weight: 100;\n  color: red;\n  position: initial;\n  text-align: left;\n  height: auto;\n  width: auto;\n}\n.has-danger[data-v-788f7aff] {\n  color: red;\n}\n.mt[data-v-788f7aff] {\n  margin-top: 7px;\n}\n.gradientbt[data-v-788f7aff] {\n  background: #0f6940;\n  color: white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-788f7aff","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/vehicles/VehicleCreate.vue
// module id = 205
// module chunks = 0